import { StringResources } from 'src/Shared/Constants';

export async function getTokenAsync(): Promise<string> {
  const token = window.getToken ? await window.getToken() : '';
  if (!token) {
    throw new Error(StringResources.UnexpectedError);
  }
  return token;
}
